module.exports = __webpack_public_path__ + "static/media/ProximaNovaA-Black.93ca0641.woff";